import { render, staticRenderFns } from "./wrong.vue?vue&type=template&id=dcbdd266&scoped=true&"
import script from "./wrong.vue?vue&type=script&lang=js&"
export * from "./wrong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbdd266",
  null
  
)

export default component.exports